import { useEffect, useMemo, useState } from 'react'
import useNotificationsList from '../../hooks/useNotificationsList'
import NotificationCard from './NotificationCard'
import InputBaseSwitch from '../inputs/InputBaseSwitch'
import { Button, MenuItem, TextField, Typography } from '@mui/material'
import { UserNotification, UserNotificationBase } from '../../types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const initialNotificationsItems = 25
const allNotificationsItems = -1
const allNotifications = 'all'

export default function ProfileNotifications() {
    const { notifications, searchLastNotifications, setAllAsConfirmed } = useNotificationsList()
    const [maxItems, setMaxItems] = useState(initialNotificationsItems)
    const [onlyUnread, setOnlyUnread] = useState(false)
    const [filter, setFilter] = useState(allNotifications)
    const filterOptions = useMemo<UserNotificationBase[]>(() => {
        let options: UserNotificationBase[] = []
        for (let notification of notifications) {
            if (!options.find(o => o.label === notification.label)) {
                options.push({ ...notification })
            }
        }
        return options
    }, [notifications])

    const notificationsItems = useMemo<UserNotification[]>(() => {
        let items = [...notifications]
        if (onlyUnread) {
            items = items.filter(i => i.status === 0)
        }
        if (filter !== allNotifications) {
            items = items.filter(i => i.label === filter)
        }
        return items
    }, [onlyUnread, notifications, filter])

    const handleOnlyUnread = (event: React.ChangeEvent<HTMLInputElement>) => {
        setOnlyUnread(event.target.checked);
    }

    useEffect(() => {
        searchLastNotifications(maxItems)
    }, [maxItems])


    return (
        <div className='form-contain notification-wrapper'>
            <div className='form-contain-row'>
                <div>
                    <TextField
                        id="filter"
                        value={filter}
                        onChange={e => setFilter(e.target.value || '')}
                        label="En vista"
                        variant='outlined'
                        size='small'
                        select
                        fullWidth
                    >
                        <MenuItem value={allNotifications}>
                            <FontAwesomeIcon icon={'bell'} style={{ marginRight: '1rem', color: 'gray' }} />
                            <span>Todas</span>
                        </MenuItem>
                        {filterOptions.map(n => <MenuItem key={n.label} value={n.label}>
                            <FontAwesomeIcon icon={n.icon} style={{ marginRight: '1rem', color: 'gray' }} />
                            <span>{n.label}</span>
                        </MenuItem>)}
                    </TextField>
                </div>
                <div className='d-flex'>
                    <InputBaseSwitch label='Solo sin confirmación' value={onlyUnread} setValue={handleOnlyUnread} />
                    <Button onClick={setAllAsConfirmed} startIcon={<FontAwesomeIcon icon="check" />} className='m-l-auto'>
                        Confirmar todas
                    </Button>
                </div>
            </div>
            <div className='notification-wrapper-data'>
                <fieldset>
                    <Typography component={'legend'} color={'gray'}>{maxItems === initialNotificationsItems ? `Mostrando últimas ${notificationsItems.length}` : `Mostrando ${notificationsItems.length} elementos`}</Typography>
                    {notificationsItems.map(n => <NotificationCard key={n.id} {...n} />)}
                    {maxItems !== allNotificationsItems && <Button fullWidth color='secondary' onClick={() => setMaxItems(allNotificationsItems)}>
                        Mostrar todas
                    </Button>}
                </fieldset>
            </div>

        </div>
    )
}
